var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlobLogo = function SvgBlobLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 142 73"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DB1717",
    d: "M55.436 68.32C19.946 74.26 3.728 70.125.55 54.96-3.357 36.317 15.397 13.87 41.668 5.273c27.5-9 38.498-5.5 61.499 5.5 31.16 14.902 50.814 42.952 27.94 59.02-17.111 9.974-40.181-7.413-75.671-1.473Z"
  })));
};
export default SvgBlobLogo;